/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as LocaleRouteImport } from './routes/$locale'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LocaleIndexRouteImport } from './routes/$locale/index'
import { Route as AuthRegisterRouteImport } from './routes/auth.register'
import { Route as AuthLoginRouteImport } from './routes/auth.login'
import { Route as LocaleWithdrawalRightsRouteImport } from './routes/$locale/withdrawal-rights'
import { Route as LocaleWelcomeRouteImport } from './routes/$locale/welcome'
import { Route as LocaleVerifyEmailRouteImport } from './routes/$locale/verify-email'
import { Route as LocaleTermsOfServiceRouteImport } from './routes/$locale/terms-of-service'
import { Route as LocaleSignUpRouteImport } from './routes/$locale/sign-up'
import { Route as LocaleSignInRouteImport } from './routes/$locale/sign-in'
import { Route as LocaleResumeGeneratorRouteImport } from './routes/$locale/resume-generator'
import { Route as LocaleRefundPolicyRouteImport } from './routes/$locale/refund-policy'
import { Route as LocalePrivacyPolicyRouteImport } from './routes/$locale/privacy-policy'
import { Route as LocalePricingRouteImport } from './routes/$locale/pricing'
import { Route as LocaleOnboardingRouteImport } from './routes/$locale/onboarding'
import { Route as LocaleLegalNoticeRouteImport } from './routes/$locale/legal-notice'
import { Route as LocaleJobsRouteImport } from './routes/$locale/jobs'
import { Route as LocaleJobTrackerRouteImport } from './routes/$locale/job-tracker'
import { Route as LocaleHealthRouteImport } from './routes/$locale/health'
import { Route as LocaleEmployerRouteImport } from './routes/$locale/employer'
import { Route as LocaleEmailPreferencesRouteImport } from './routes/$locale/email-preferences'
import { Route as LocaleDashboardRouteImport } from './routes/$locale/dashboard'
import { Route as LocaleCoverLetterGeneratorRouteImport } from './routes/$locale/cover-letter-generator'
import { Route as LocaleCookiePolicyRouteImport } from './routes/$locale/cookie-policy'
import { Route as LocaleContactRouteImport } from './routes/$locale/contact'
import { Route as LocaleBrowseRouteImport } from './routes/$locale/browse'
import { Route as LocaleAdminRouteImport } from './routes/$locale/admin'
import { Route as LocaleAccessibilityStatementRouteImport } from './routes/$locale/accessibility-statement'
import { Route as Locale2faChallengeRouteImport } from './routes/$locale/2fa-challenge'
import { Route as LocaleEmployerIndexRouteImport } from './routes/$locale/employer.index'
import { Route as LocaleDashboardIndexRouteImport } from './routes/$locale/dashboard.index'
import { Route as LocaleSettingsResumeRouteImport } from './routes/$locale/settings.resume'
import { Route as LocaleSettingsAlertsRouteImport } from './routes/$locale/settings.alerts'
import { Route as LocaleOauthCallbackRouteImport } from './routes/$locale/oauth.callback'
import { Route as LocaleJobsJobIdRouteImport } from './routes/$locale/jobs.$jobId'
import { Route as LocaleEmployerCompanyIdRouteImport } from './routes/$locale/employer.$companyId'
import { Route as LocaleDashboardUsageRouteImport } from './routes/$locale/dashboard.usage'
import { Route as LocaleDashboardSubscriptionRouteImport } from './routes/$locale/dashboard.subscription'
import { Route as LocaleDashboardSettingsRouteImport } from './routes/$locale/dashboard.settings'
import { Route as LocaleDashboardSalaryNegotiationRouteImport } from './routes/$locale/dashboard.salary-negotiation'
import { Route as LocaleDashboardSalaryInsightsRouteImport } from './routes/$locale/dashboard.salary-insights'
import { Route as LocaleDashboardResumeAnalysisRouteImport } from './routes/$locale/dashboard.resume-analysis'
import { Route as LocaleDashboardReportsRouteImport } from './routes/$locale/dashboard.reports'
import { Route as LocaleDashboardReferralRouteImport } from './routes/$locale/dashboard.referral'
import { Route as LocaleDashboardProfileRouteImport } from './routes/$locale/dashboard.profile'
import { Route as LocaleDashboardOverviewRouteImport } from './routes/$locale/dashboard.overview'
import { Route as LocaleDashboardMockInterviewRouteImport } from './routes/$locale/dashboard.mock-interview'
import { Route as LocaleDashboardJobPreferencesRouteImport } from './routes/$locale/dashboard.job-preferences'
import { Route as LocaleDashboardGrowthRouteImport } from './routes/$locale/dashboard.growth'
import { Route as LocaleDashboardCreditsRouteImport } from './routes/$locale/dashboard.credits'
import { Route as LocaleDashboardCoverLetterRouteImport } from './routes/$locale/dashboard.cover-letter'
import { Route as LocaleDashboardCareerAdvisorRouteImport } from './routes/$locale/dashboard.career-advisor'
import { Route as LocaleDashboardAiSearchRouteImport } from './routes/$locale/dashboard.ai-search'
import { Route as LocaleDashboardAiFeaturesRouteImport } from './routes/$locale/dashboard.ai-features'
import { Route as LocaleDashboardAiChatRouteImport } from './routes/$locale/dashboard.ai-chat'
import { Route as LocaleAdminWithdrawalsRouteImport } from './routes/$locale/admin.withdrawals'
import { Route as LocaleAdminUsersRouteImport } from './routes/$locale/admin.users'
import { Route as LocaleAdminRagHealthRouteImport } from './routes/$locale/admin.rag-health'
import { Route as LocaleAdminModerationRouteImport } from './routes/$locale/admin.moderation'
import { Route as LocaleAdminMigrationStatsRouteImport } from './routes/$locale/admin.migration-stats'
import { Route as LocaleAdminLanguageAnalyticsRouteImport } from './routes/$locale/admin.language-analytics'
import { Route as LocaleAdminIngestionHealthRouteImport } from './routes/$locale/admin.ingestion-health'
import { Route as LocaleAdminFeatureFlagsRouteImport } from './routes/$locale/admin.feature-flags'
import { Route as LocaleAdminDocsSearchRouteImport } from './routes/$locale/admin.docs-search'
import { Route as LocaleAdminBillingRouteImport } from './routes/$locale/admin.billing'
import { Route as LocaleAdminAnalyticsRouteImport } from './routes/$locale/admin.analytics'
import { Route as LocaleAdminAiMetricsRouteImport } from './routes/$locale/admin.ai-metrics'
import { Route as LocaleSettingsAlertsNewRouteImport } from './routes/$locale/settings.alerts.new'
import { Route as LocaleEmployerCompanyIdSettingsRouteImport } from './routes/$locale/employer.$companyId.settings'
import { Route as LocaleEmployerCompanyIdJobsRouteImport } from './routes/$locale/employer.$companyId.jobs'
import { Route as LocaleEmployerCompanyIdBillingRouteImport } from './routes/$locale/employer.$companyId.billing'
import { Route as LocaleEmployerCompanyIdApplicationsRouteImport } from './routes/$locale/employer.$companyId.applications'
import { Route as LocaleAdminBlogQueueRouteImport } from './routes/$locale/admin.blog.queue'
import { Route as LocaleEmployerCompanyIdJobsIndexRouteImport } from './routes/$locale/employer.$companyId.jobs.index'
import { Route as LocaleEmployerCompanyIdJobsNewRouteImport } from './routes/$locale/employer.$companyId.jobs.new'
import { Route as LocaleEmployerCompanyIdJobsJobIdRouteImport } from './routes/$locale/employer.$companyId.jobs.$jobId'

const LocaleEmployerCreateLazyRouteImport = createFileRoute(
  '/$locale/employer/create',
)()
const LocaleEmployerCompanyIdIndexLazyRouteImport = createFileRoute(
  '/$locale/employer/$companyId/',
)()

const LocaleRoute = LocaleRouteImport.update({
  id: '/$locale',
  path: '/$locale',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LocaleIndexRoute = LocaleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LocaleRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/auth/register',
  path: '/auth/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LocaleWithdrawalRightsRoute = LocaleWithdrawalRightsRouteImport.update({
  id: '/withdrawal-rights',
  path: '/withdrawal-rights',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/withdrawal-rights.lazy').then((d) => d.Route),
)
const LocaleWelcomeRoute = LocaleWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/welcome.lazy').then((d) => d.Route),
)
const LocaleVerifyEmailRoute = LocaleVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/verify-email.lazy').then((d) => d.Route),
)
const LocaleTermsOfServiceRoute = LocaleTermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/terms-of-service.lazy').then((d) => d.Route),
)
const LocaleSignUpRoute = LocaleSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/sign-up.lazy').then((d) => d.Route),
)
const LocaleSignInRoute = LocaleSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/sign-in.lazy').then((d) => d.Route),
)
const LocaleResumeGeneratorRoute = LocaleResumeGeneratorRouteImport.update({
  id: '/resume-generator',
  path: '/resume-generator',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/resume-generator.lazy').then((d) => d.Route),
)
const LocaleRefundPolicyRoute = LocaleRefundPolicyRouteImport.update({
  id: '/refund-policy',
  path: '/refund-policy',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/refund-policy.lazy').then((d) => d.Route),
)
const LocalePrivacyPolicyRoute = LocalePrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/privacy-policy.lazy').then((d) => d.Route),
)
const LocalePricingRoute = LocalePricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/pricing.lazy').then((d) => d.Route),
)
const LocaleOnboardingRoute = LocaleOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/onboarding.lazy').then((d) => d.Route),
)
const LocaleLegalNoticeRoute = LocaleLegalNoticeRouteImport.update({
  id: '/legal-notice',
  path: '/legal-notice',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/legal-notice.lazy').then((d) => d.Route),
)
const LocaleJobsRoute = LocaleJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() => import('./routes/$locale/jobs.lazy').then((d) => d.Route))
const LocaleJobTrackerRoute = LocaleJobTrackerRouteImport.update({
  id: '/job-tracker',
  path: '/job-tracker',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/job-tracker.lazy').then((d) => d.Route),
)
const LocaleHealthRoute = LocaleHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleEmployerRoute = LocaleEmployerRouteImport.update({
  id: '/employer',
  path: '/employer',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/employer.lazy').then((d) => d.Route),
)
const LocaleEmailPreferencesRoute = LocaleEmailPreferencesRouteImport.update({
  id: '/email-preferences',
  path: '/email-preferences',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/email-preferences.lazy').then((d) => d.Route),
)
const LocaleDashboardRoute = LocaleDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/dashboard.lazy').then((d) => d.Route),
)
const LocaleCoverLetterGeneratorRoute =
  LocaleCoverLetterGeneratorRouteImport.update({
    id: '/cover-letter-generator',
    path: '/cover-letter-generator',
    getParentRoute: () => LocaleRoute,
  } as any).lazy(() =>
    import('./routes/$locale/cover-letter-generator.lazy').then((d) => d.Route),
  )
const LocaleCookiePolicyRoute = LocaleCookiePolicyRouteImport.update({
  id: '/cookie-policy',
  path: '/cookie-policy',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/cookie-policy.lazy').then((d) => d.Route),
)
const LocaleContactRoute = LocaleContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/contact.lazy').then((d) => d.Route),
)
const LocaleBrowseRoute = LocaleBrowseRouteImport.update({
  id: '/browse',
  path: '/browse',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/browse.lazy').then((d) => d.Route),
)
const LocaleAdminRoute = LocaleAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() => import('./routes/$locale/admin.lazy').then((d) => d.Route))
const LocaleAccessibilityStatementRoute =
  LocaleAccessibilityStatementRouteImport.update({
    id: '/accessibility-statement',
    path: '/accessibility-statement',
    getParentRoute: () => LocaleRoute,
  } as any).lazy(() =>
    import('./routes/$locale/accessibility-statement.lazy').then(
      (d) => d.Route,
    ),
  )
const Locale2faChallengeRoute = Locale2faChallengeRouteImport.update({
  id: '/2fa-challenge',
  path: '/2fa-challenge',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/2fa-challenge.lazy').then((d) => d.Route),
)
const LocaleEmployerIndexRoute = LocaleEmployerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LocaleEmployerRoute,
} as any)
const LocaleDashboardIndexRoute = LocaleDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LocaleDashboardRoute,
} as any)
const LocaleEmployerCreateLazyRoute =
  LocaleEmployerCreateLazyRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => LocaleEmployerRoute,
  } as any).lazy(() =>
    import('./routes/$locale/employer.create.lazy').then((d) => d.Route),
  )
const LocaleSettingsResumeRoute = LocaleSettingsResumeRouteImport.update({
  id: '/settings/resume',
  path: '/settings/resume',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/settings.resume.lazy').then((d) => d.Route),
)
const LocaleSettingsAlertsRoute = LocaleSettingsAlertsRouteImport.update({
  id: '/settings/alerts',
  path: '/settings/alerts',
  getParentRoute: () => LocaleRoute,
} as any).lazy(() =>
  import('./routes/$locale/settings.alerts.lazy').then((d) => d.Route),
)
const LocaleOauthCallbackRoute = LocaleOauthCallbackRouteImport.update({
  id: '/oauth/callback',
  path: '/oauth/callback',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleJobsJobIdRoute = LocaleJobsJobIdRouteImport.update({
  id: '/$jobId',
  path: '/$jobId',
  getParentRoute: () => LocaleJobsRoute,
} as any).lazy(() =>
  import('./routes/$locale/jobs.$jobId.lazy').then((d) => d.Route),
)
const LocaleEmployerCompanyIdRoute = LocaleEmployerCompanyIdRouteImport.update({
  id: '/$companyId',
  path: '/$companyId',
  getParentRoute: () => LocaleEmployerRoute,
} as any).lazy(() =>
  import('./routes/$locale/employer.$companyId.lazy').then((d) => d.Route),
)
const LocaleDashboardUsageRoute = LocaleDashboardUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => LocaleDashboardRoute,
} as any).lazy(() =>
  import('./routes/$locale/dashboard.usage.lazy').then((d) => d.Route),
)
const LocaleDashboardSubscriptionRoute =
  LocaleDashboardSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => LocaleDashboardRoute,
  } as any).lazy(() =>
    import('./routes/$locale/dashboard.subscription.lazy').then((d) => d.Route),
  )
const LocaleDashboardSettingsRoute = LocaleDashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => LocaleDashboardRoute,
} as any).lazy(() =>
  import('./routes/$locale/dashboard.settings.lazy').then((d) => d.Route),
)
const LocaleDashboardSalaryNegotiationRoute =
  LocaleDashboardSalaryNegotiationRouteImport.update({
    id: '/salary-negotiation',
    path: '/salary-negotiation',
    getParentRoute: () => LocaleDashboardRoute,
  } as any).lazy(() =>
    import('./routes/$locale/dashboard.salary-negotiation.lazy').then(
      (d) => d.Route,
    ),
  )
const LocaleDashboardSalaryInsightsRoute =
  LocaleDashboardSalaryInsightsRouteImport.update({
    id: '/salary-insights',
    path: '/salary-insights',
    getParentRoute: () => LocaleDashboardRoute,
  } as any).lazy(() =>
    import('./routes/$locale/dashboard.salary-insights.lazy').then(
      (d) => d.Route,
    ),
  )
const LocaleDashboardResumeAnalysisRoute =
  LocaleDashboardResumeAnalysisRouteImport.update({
    id: '/resume-analysis',
    path: '/resume-analysis',
    getParentRoute: () => LocaleDashboardRoute,
  } as any).lazy(() =>
    import('./routes/$locale/dashboard.resume-analysis.lazy').then(
      (d) => d.Route,
    ),
  )
const LocaleDashboardReportsRoute = LocaleDashboardReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => LocaleDashboardRoute,
} as any).lazy(() =>
  import('./routes/$locale/dashboard.reports.lazy').then((d) => d.Route),
)
const LocaleDashboardReferralRoute = LocaleDashboardReferralRouteImport.update({
  id: '/referral',
  path: '/referral',
  getParentRoute: () => LocaleDashboardRoute,
} as any).lazy(() =>
  import('./routes/$locale/dashboard.referral.lazy').then((d) => d.Route),
)
const LocaleDashboardProfileRoute = LocaleDashboardProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => LocaleDashboardRoute,
} as any).lazy(() =>
  import('./routes/$locale/dashboard.profile.lazy').then((d) => d.Route),
)
const LocaleDashboardOverviewRoute = LocaleDashboardOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => LocaleDashboardRoute,
} as any).lazy(() =>
  import('./routes/$locale/dashboard.overview.lazy').then((d) => d.Route),
)
const LocaleDashboardMockInterviewRoute =
  LocaleDashboardMockInterviewRouteImport.update({
    id: '/mock-interview',
    path: '/mock-interview',
    getParentRoute: () => LocaleDashboardRoute,
  } as any).lazy(() =>
    import('./routes/$locale/dashboard.mock-interview.lazy').then(
      (d) => d.Route,
    ),
  )
const LocaleDashboardJobPreferencesRoute =
  LocaleDashboardJobPreferencesRouteImport.update({
    id: '/job-preferences',
    path: '/job-preferences',
    getParentRoute: () => LocaleDashboardRoute,
  } as any).lazy(() =>
    import('./routes/$locale/dashboard.job-preferences.lazy').then(
      (d) => d.Route,
    ),
  )
const LocaleDashboardGrowthRoute = LocaleDashboardGrowthRouteImport.update({
  id: '/growth',
  path: '/growth',
  getParentRoute: () => LocaleDashboardRoute,
} as any).lazy(() =>
  import('./routes/$locale/dashboard.growth.lazy').then((d) => d.Route),
)
const LocaleDashboardCreditsRoute = LocaleDashboardCreditsRouteImport.update({
  id: '/credits',
  path: '/credits',
  getParentRoute: () => LocaleDashboardRoute,
} as any).lazy(() =>
  import('./routes/$locale/dashboard.credits.lazy').then((d) => d.Route),
)
const LocaleDashboardCoverLetterRoute =
  LocaleDashboardCoverLetterRouteImport.update({
    id: '/cover-letter',
    path: '/cover-letter',
    getParentRoute: () => LocaleDashboardRoute,
  } as any).lazy(() =>
    import('./routes/$locale/dashboard.cover-letter.lazy').then((d) => d.Route),
  )
const LocaleDashboardCareerAdvisorRoute =
  LocaleDashboardCareerAdvisorRouteImport.update({
    id: '/career-advisor',
    path: '/career-advisor',
    getParentRoute: () => LocaleDashboardRoute,
  } as any).lazy(() =>
    import('./routes/$locale/dashboard.career-advisor.lazy').then(
      (d) => d.Route,
    ),
  )
const LocaleDashboardAiSearchRoute = LocaleDashboardAiSearchRouteImport.update({
  id: '/ai-search',
  path: '/ai-search',
  getParentRoute: () => LocaleDashboardRoute,
} as any)
const LocaleDashboardAiFeaturesRoute =
  LocaleDashboardAiFeaturesRouteImport.update({
    id: '/ai-features',
    path: '/ai-features',
    getParentRoute: () => LocaleDashboardRoute,
  } as any).lazy(() =>
    import('./routes/$locale/dashboard.ai-features.lazy').then((d) => d.Route),
  )
const LocaleDashboardAiChatRoute = LocaleDashboardAiChatRouteImport.update({
  id: '/ai-chat',
  path: '/ai-chat',
  getParentRoute: () => LocaleDashboardRoute,
} as any).lazy(() =>
  import('./routes/$locale/dashboard.ai-chat.lazy').then((d) => d.Route),
)
const LocaleAdminWithdrawalsRoute = LocaleAdminWithdrawalsRouteImport.update({
  id: '/withdrawals',
  path: '/withdrawals',
  getParentRoute: () => LocaleAdminRoute,
} as any).lazy(() =>
  import('./routes/$locale/admin.withdrawals.lazy').then((d) => d.Route),
)
const LocaleAdminUsersRoute = LocaleAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => LocaleAdminRoute,
} as any).lazy(() =>
  import('./routes/$locale/admin.users.lazy').then((d) => d.Route),
)
const LocaleAdminRagHealthRoute = LocaleAdminRagHealthRouteImport.update({
  id: '/rag-health',
  path: '/rag-health',
  getParentRoute: () => LocaleAdminRoute,
} as any).lazy(() =>
  import('./routes/$locale/admin.rag-health.lazy').then((d) => d.Route),
)
const LocaleAdminModerationRoute = LocaleAdminModerationRouteImport.update({
  id: '/moderation',
  path: '/moderation',
  getParentRoute: () => LocaleAdminRoute,
} as any).lazy(() =>
  import('./routes/$locale/admin.moderation.lazy').then((d) => d.Route),
)
const LocaleAdminMigrationStatsRoute =
  LocaleAdminMigrationStatsRouteImport.update({
    id: '/migration-stats',
    path: '/migration-stats',
    getParentRoute: () => LocaleAdminRoute,
  } as any).lazy(() =>
    import('./routes/$locale/admin.migration-stats.lazy').then((d) => d.Route),
  )
const LocaleAdminLanguageAnalyticsRoute =
  LocaleAdminLanguageAnalyticsRouteImport.update({
    id: '/language-analytics',
    path: '/language-analytics',
    getParentRoute: () => LocaleAdminRoute,
  } as any).lazy(() =>
    import('./routes/$locale/admin.language-analytics.lazy').then(
      (d) => d.Route,
    ),
  )
const LocaleAdminIngestionHealthRoute =
  LocaleAdminIngestionHealthRouteImport.update({
    id: '/ingestion-health',
    path: '/ingestion-health',
    getParentRoute: () => LocaleAdminRoute,
  } as any).lazy(() =>
    import('./routes/$locale/admin.ingestion-health.lazy').then((d) => d.Route),
  )
const LocaleAdminFeatureFlagsRoute = LocaleAdminFeatureFlagsRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => LocaleAdminRoute,
} as any).lazy(() =>
  import('./routes/$locale/admin.feature-flags.lazy').then((d) => d.Route),
)
const LocaleAdminDocsSearchRoute = LocaleAdminDocsSearchRouteImport.update({
  id: '/docs-search',
  path: '/docs-search',
  getParentRoute: () => LocaleAdminRoute,
} as any).lazy(() =>
  import('./routes/$locale/admin.docs-search.lazy').then((d) => d.Route),
)
const LocaleAdminBillingRoute = LocaleAdminBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => LocaleAdminRoute,
} as any).lazy(() =>
  import('./routes/$locale/admin.billing.lazy').then((d) => d.Route),
)
const LocaleAdminAnalyticsRoute = LocaleAdminAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => LocaleAdminRoute,
} as any).lazy(() =>
  import('./routes/$locale/admin.analytics.lazy').then((d) => d.Route),
)
const LocaleAdminAiMetricsRoute = LocaleAdminAiMetricsRouteImport.update({
  id: '/ai-metrics',
  path: '/ai-metrics',
  getParentRoute: () => LocaleAdminRoute,
} as any).lazy(() =>
  import('./routes/$locale/admin.ai-metrics.lazy').then((d) => d.Route),
)
const LocaleEmployerCompanyIdIndexLazyRoute =
  LocaleEmployerCompanyIdIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleEmployerCompanyIdRoute,
  } as any).lazy(() =>
    import('./routes/$locale/employer.$companyId.index.lazy').then(
      (d) => d.Route,
    ),
  )
const LocaleSettingsAlertsNewRoute = LocaleSettingsAlertsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => LocaleSettingsAlertsRoute,
} as any).lazy(() =>
  import('./routes/$locale/settings.alerts.new.lazy').then((d) => d.Route),
)
const LocaleEmployerCompanyIdSettingsRoute =
  LocaleEmployerCompanyIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => LocaleEmployerCompanyIdRoute,
  } as any).lazy(() =>
    import('./routes/$locale/employer.$companyId.settings.lazy').then(
      (d) => d.Route,
    ),
  )
const LocaleEmployerCompanyIdJobsRoute =
  LocaleEmployerCompanyIdJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => LocaleEmployerCompanyIdRoute,
  } as any).lazy(() =>
    import('./routes/$locale/employer.$companyId.jobs.lazy').then(
      (d) => d.Route,
    ),
  )
const LocaleEmployerCompanyIdBillingRoute =
  LocaleEmployerCompanyIdBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => LocaleEmployerCompanyIdRoute,
  } as any).lazy(() =>
    import('./routes/$locale/employer.$companyId.billing.lazy').then(
      (d) => d.Route,
    ),
  )
const LocaleEmployerCompanyIdApplicationsRoute =
  LocaleEmployerCompanyIdApplicationsRouteImport.update({
    id: '/applications',
    path: '/applications',
    getParentRoute: () => LocaleEmployerCompanyIdRoute,
  } as any).lazy(() =>
    import('./routes/$locale/employer.$companyId.applications.lazy').then(
      (d) => d.Route,
    ),
  )
const LocaleAdminBlogQueueRoute = LocaleAdminBlogQueueRouteImport.update({
  id: '/blog/queue',
  path: '/blog/queue',
  getParentRoute: () => LocaleAdminRoute,
} as any).lazy(() =>
  import('./routes/$locale/admin.blog.queue.lazy').then((d) => d.Route),
)
const LocaleEmployerCompanyIdJobsIndexRoute =
  LocaleEmployerCompanyIdJobsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleEmployerCompanyIdJobsRoute,
  } as any).lazy(() =>
    import('./routes/$locale/employer.$companyId.jobs.index.lazy').then(
      (d) => d.Route,
    ),
  )
const LocaleEmployerCompanyIdJobsNewRoute =
  LocaleEmployerCompanyIdJobsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => LocaleEmployerCompanyIdJobsRoute,
  } as any).lazy(() =>
    import('./routes/$locale/employer.$companyId.jobs.new.lazy').then(
      (d) => d.Route,
    ),
  )
const LocaleEmployerCompanyIdJobsJobIdRoute =
  LocaleEmployerCompanyIdJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => LocaleEmployerCompanyIdJobsRoute,
  } as any).lazy(() =>
    import('./routes/$locale/employer.$companyId.jobs.$jobId.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/$locale': typeof LocaleRouteWithChildren
  '/$locale/2fa-challenge': typeof Locale2faChallengeRoute
  '/$locale/accessibility-statement': typeof LocaleAccessibilityStatementRoute
  '/$locale/admin': typeof LocaleAdminRouteWithChildren
  '/$locale/browse': typeof LocaleBrowseRoute
  '/$locale/contact': typeof LocaleContactRoute
  '/$locale/cookie-policy': typeof LocaleCookiePolicyRoute
  '/$locale/cover-letter-generator': typeof LocaleCoverLetterGeneratorRoute
  '/$locale/dashboard': typeof LocaleDashboardRouteWithChildren
  '/$locale/email-preferences': typeof LocaleEmailPreferencesRoute
  '/$locale/employer': typeof LocaleEmployerRouteWithChildren
  '/$locale/health': typeof LocaleHealthRoute
  '/$locale/job-tracker': typeof LocaleJobTrackerRoute
  '/$locale/jobs': typeof LocaleJobsRouteWithChildren
  '/$locale/legal-notice': typeof LocaleLegalNoticeRoute
  '/$locale/onboarding': typeof LocaleOnboardingRoute
  '/$locale/pricing': typeof LocalePricingRoute
  '/$locale/privacy-policy': typeof LocalePrivacyPolicyRoute
  '/$locale/refund-policy': typeof LocaleRefundPolicyRoute
  '/$locale/resume-generator': typeof LocaleResumeGeneratorRoute
  '/$locale/sign-in': typeof LocaleSignInRoute
  '/$locale/sign-up': typeof LocaleSignUpRoute
  '/$locale/terms-of-service': typeof LocaleTermsOfServiceRoute
  '/$locale/verify-email': typeof LocaleVerifyEmailRoute
  '/$locale/welcome': typeof LocaleWelcomeRoute
  '/$locale/withdrawal-rights': typeof LocaleWithdrawalRightsRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/$locale/': typeof LocaleIndexRoute
  '/$locale/admin/ai-metrics': typeof LocaleAdminAiMetricsRoute
  '/$locale/admin/analytics': typeof LocaleAdminAnalyticsRoute
  '/$locale/admin/billing': typeof LocaleAdminBillingRoute
  '/$locale/admin/docs-search': typeof LocaleAdminDocsSearchRoute
  '/$locale/admin/feature-flags': typeof LocaleAdminFeatureFlagsRoute
  '/$locale/admin/ingestion-health': typeof LocaleAdminIngestionHealthRoute
  '/$locale/admin/language-analytics': typeof LocaleAdminLanguageAnalyticsRoute
  '/$locale/admin/migration-stats': typeof LocaleAdminMigrationStatsRoute
  '/$locale/admin/moderation': typeof LocaleAdminModerationRoute
  '/$locale/admin/rag-health': typeof LocaleAdminRagHealthRoute
  '/$locale/admin/users': typeof LocaleAdminUsersRoute
  '/$locale/admin/withdrawals': typeof LocaleAdminWithdrawalsRoute
  '/$locale/dashboard/ai-chat': typeof LocaleDashboardAiChatRoute
  '/$locale/dashboard/ai-features': typeof LocaleDashboardAiFeaturesRoute
  '/$locale/dashboard/ai-search': typeof LocaleDashboardAiSearchRoute
  '/$locale/dashboard/career-advisor': typeof LocaleDashboardCareerAdvisorRoute
  '/$locale/dashboard/cover-letter': typeof LocaleDashboardCoverLetterRoute
  '/$locale/dashboard/credits': typeof LocaleDashboardCreditsRoute
  '/$locale/dashboard/growth': typeof LocaleDashboardGrowthRoute
  '/$locale/dashboard/job-preferences': typeof LocaleDashboardJobPreferencesRoute
  '/$locale/dashboard/mock-interview': typeof LocaleDashboardMockInterviewRoute
  '/$locale/dashboard/overview': typeof LocaleDashboardOverviewRoute
  '/$locale/dashboard/profile': typeof LocaleDashboardProfileRoute
  '/$locale/dashboard/referral': typeof LocaleDashboardReferralRoute
  '/$locale/dashboard/reports': typeof LocaleDashboardReportsRoute
  '/$locale/dashboard/resume-analysis': typeof LocaleDashboardResumeAnalysisRoute
  '/$locale/dashboard/salary-insights': typeof LocaleDashboardSalaryInsightsRoute
  '/$locale/dashboard/salary-negotiation': typeof LocaleDashboardSalaryNegotiationRoute
  '/$locale/dashboard/settings': typeof LocaleDashboardSettingsRoute
  '/$locale/dashboard/subscription': typeof LocaleDashboardSubscriptionRoute
  '/$locale/dashboard/usage': typeof LocaleDashboardUsageRoute
  '/$locale/employer/$companyId': typeof LocaleEmployerCompanyIdRouteWithChildren
  '/$locale/jobs/$jobId': typeof LocaleJobsJobIdRoute
  '/$locale/oauth/callback': typeof LocaleOauthCallbackRoute
  '/$locale/settings/alerts': typeof LocaleSettingsAlertsRouteWithChildren
  '/$locale/settings/resume': typeof LocaleSettingsResumeRoute
  '/$locale/employer/create': typeof LocaleEmployerCreateLazyRoute
  '/$locale/dashboard/': typeof LocaleDashboardIndexRoute
  '/$locale/employer/': typeof LocaleEmployerIndexRoute
  '/$locale/admin/blog/queue': typeof LocaleAdminBlogQueueRoute
  '/$locale/employer/$companyId/applications': typeof LocaleEmployerCompanyIdApplicationsRoute
  '/$locale/employer/$companyId/billing': typeof LocaleEmployerCompanyIdBillingRoute
  '/$locale/employer/$companyId/jobs': typeof LocaleEmployerCompanyIdJobsRouteWithChildren
  '/$locale/employer/$companyId/settings': typeof LocaleEmployerCompanyIdSettingsRoute
  '/$locale/settings/alerts/new': typeof LocaleSettingsAlertsNewRoute
  '/$locale/employer/$companyId/': typeof LocaleEmployerCompanyIdIndexLazyRoute
  '/$locale/employer/$companyId/jobs/$jobId': typeof LocaleEmployerCompanyIdJobsJobIdRoute
  '/$locale/employer/$companyId/jobs/new': typeof LocaleEmployerCompanyIdJobsNewRoute
  '/$locale/employer/$companyId/jobs/': typeof LocaleEmployerCompanyIdJobsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/$locale/2fa-challenge': typeof Locale2faChallengeRoute
  '/$locale/accessibility-statement': typeof LocaleAccessibilityStatementRoute
  '/$locale/admin': typeof LocaleAdminRouteWithChildren
  '/$locale/browse': typeof LocaleBrowseRoute
  '/$locale/contact': typeof LocaleContactRoute
  '/$locale/cookie-policy': typeof LocaleCookiePolicyRoute
  '/$locale/cover-letter-generator': typeof LocaleCoverLetterGeneratorRoute
  '/$locale/email-preferences': typeof LocaleEmailPreferencesRoute
  '/$locale/health': typeof LocaleHealthRoute
  '/$locale/job-tracker': typeof LocaleJobTrackerRoute
  '/$locale/jobs': typeof LocaleJobsRouteWithChildren
  '/$locale/legal-notice': typeof LocaleLegalNoticeRoute
  '/$locale/onboarding': typeof LocaleOnboardingRoute
  '/$locale/pricing': typeof LocalePricingRoute
  '/$locale/privacy-policy': typeof LocalePrivacyPolicyRoute
  '/$locale/refund-policy': typeof LocaleRefundPolicyRoute
  '/$locale/resume-generator': typeof LocaleResumeGeneratorRoute
  '/$locale/sign-in': typeof LocaleSignInRoute
  '/$locale/sign-up': typeof LocaleSignUpRoute
  '/$locale/terms-of-service': typeof LocaleTermsOfServiceRoute
  '/$locale/verify-email': typeof LocaleVerifyEmailRoute
  '/$locale/welcome': typeof LocaleWelcomeRoute
  '/$locale/withdrawal-rights': typeof LocaleWithdrawalRightsRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/$locale': typeof LocaleIndexRoute
  '/$locale/admin/ai-metrics': typeof LocaleAdminAiMetricsRoute
  '/$locale/admin/analytics': typeof LocaleAdminAnalyticsRoute
  '/$locale/admin/billing': typeof LocaleAdminBillingRoute
  '/$locale/admin/docs-search': typeof LocaleAdminDocsSearchRoute
  '/$locale/admin/feature-flags': typeof LocaleAdminFeatureFlagsRoute
  '/$locale/admin/ingestion-health': typeof LocaleAdminIngestionHealthRoute
  '/$locale/admin/language-analytics': typeof LocaleAdminLanguageAnalyticsRoute
  '/$locale/admin/migration-stats': typeof LocaleAdminMigrationStatsRoute
  '/$locale/admin/moderation': typeof LocaleAdminModerationRoute
  '/$locale/admin/rag-health': typeof LocaleAdminRagHealthRoute
  '/$locale/admin/users': typeof LocaleAdminUsersRoute
  '/$locale/admin/withdrawals': typeof LocaleAdminWithdrawalsRoute
  '/$locale/dashboard/ai-chat': typeof LocaleDashboardAiChatRoute
  '/$locale/dashboard/ai-features': typeof LocaleDashboardAiFeaturesRoute
  '/$locale/dashboard/ai-search': typeof LocaleDashboardAiSearchRoute
  '/$locale/dashboard/career-advisor': typeof LocaleDashboardCareerAdvisorRoute
  '/$locale/dashboard/cover-letter': typeof LocaleDashboardCoverLetterRoute
  '/$locale/dashboard/credits': typeof LocaleDashboardCreditsRoute
  '/$locale/dashboard/growth': typeof LocaleDashboardGrowthRoute
  '/$locale/dashboard/job-preferences': typeof LocaleDashboardJobPreferencesRoute
  '/$locale/dashboard/mock-interview': typeof LocaleDashboardMockInterviewRoute
  '/$locale/dashboard/overview': typeof LocaleDashboardOverviewRoute
  '/$locale/dashboard/profile': typeof LocaleDashboardProfileRoute
  '/$locale/dashboard/referral': typeof LocaleDashboardReferralRoute
  '/$locale/dashboard/reports': typeof LocaleDashboardReportsRoute
  '/$locale/dashboard/resume-analysis': typeof LocaleDashboardResumeAnalysisRoute
  '/$locale/dashboard/salary-insights': typeof LocaleDashboardSalaryInsightsRoute
  '/$locale/dashboard/salary-negotiation': typeof LocaleDashboardSalaryNegotiationRoute
  '/$locale/dashboard/settings': typeof LocaleDashboardSettingsRoute
  '/$locale/dashboard/subscription': typeof LocaleDashboardSubscriptionRoute
  '/$locale/dashboard/usage': typeof LocaleDashboardUsageRoute
  '/$locale/jobs/$jobId': typeof LocaleJobsJobIdRoute
  '/$locale/oauth/callback': typeof LocaleOauthCallbackRoute
  '/$locale/settings/alerts': typeof LocaleSettingsAlertsRouteWithChildren
  '/$locale/settings/resume': typeof LocaleSettingsResumeRoute
  '/$locale/employer/create': typeof LocaleEmployerCreateLazyRoute
  '/$locale/dashboard': typeof LocaleDashboardIndexRoute
  '/$locale/employer': typeof LocaleEmployerIndexRoute
  '/$locale/admin/blog/queue': typeof LocaleAdminBlogQueueRoute
  '/$locale/employer/$companyId/applications': typeof LocaleEmployerCompanyIdApplicationsRoute
  '/$locale/employer/$companyId/billing': typeof LocaleEmployerCompanyIdBillingRoute
  '/$locale/employer/$companyId/settings': typeof LocaleEmployerCompanyIdSettingsRoute
  '/$locale/settings/alerts/new': typeof LocaleSettingsAlertsNewRoute
  '/$locale/employer/$companyId': typeof LocaleEmployerCompanyIdIndexLazyRoute
  '/$locale/employer/$companyId/jobs/$jobId': typeof LocaleEmployerCompanyIdJobsJobIdRoute
  '/$locale/employer/$companyId/jobs/new': typeof LocaleEmployerCompanyIdJobsNewRoute
  '/$locale/employer/$companyId/jobs': typeof LocaleEmployerCompanyIdJobsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/$locale': typeof LocaleRouteWithChildren
  '/$locale/2fa-challenge': typeof Locale2faChallengeRoute
  '/$locale/accessibility-statement': typeof LocaleAccessibilityStatementRoute
  '/$locale/admin': typeof LocaleAdminRouteWithChildren
  '/$locale/browse': typeof LocaleBrowseRoute
  '/$locale/contact': typeof LocaleContactRoute
  '/$locale/cookie-policy': typeof LocaleCookiePolicyRoute
  '/$locale/cover-letter-generator': typeof LocaleCoverLetterGeneratorRoute
  '/$locale/dashboard': typeof LocaleDashboardRouteWithChildren
  '/$locale/email-preferences': typeof LocaleEmailPreferencesRoute
  '/$locale/employer': typeof LocaleEmployerRouteWithChildren
  '/$locale/health': typeof LocaleHealthRoute
  '/$locale/job-tracker': typeof LocaleJobTrackerRoute
  '/$locale/jobs': typeof LocaleJobsRouteWithChildren
  '/$locale/legal-notice': typeof LocaleLegalNoticeRoute
  '/$locale/onboarding': typeof LocaleOnboardingRoute
  '/$locale/pricing': typeof LocalePricingRoute
  '/$locale/privacy-policy': typeof LocalePrivacyPolicyRoute
  '/$locale/refund-policy': typeof LocaleRefundPolicyRoute
  '/$locale/resume-generator': typeof LocaleResumeGeneratorRoute
  '/$locale/sign-in': typeof LocaleSignInRoute
  '/$locale/sign-up': typeof LocaleSignUpRoute
  '/$locale/terms-of-service': typeof LocaleTermsOfServiceRoute
  '/$locale/verify-email': typeof LocaleVerifyEmailRoute
  '/$locale/welcome': typeof LocaleWelcomeRoute
  '/$locale/withdrawal-rights': typeof LocaleWithdrawalRightsRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/$locale/': typeof LocaleIndexRoute
  '/$locale/admin/ai-metrics': typeof LocaleAdminAiMetricsRoute
  '/$locale/admin/analytics': typeof LocaleAdminAnalyticsRoute
  '/$locale/admin/billing': typeof LocaleAdminBillingRoute
  '/$locale/admin/docs-search': typeof LocaleAdminDocsSearchRoute
  '/$locale/admin/feature-flags': typeof LocaleAdminFeatureFlagsRoute
  '/$locale/admin/ingestion-health': typeof LocaleAdminIngestionHealthRoute
  '/$locale/admin/language-analytics': typeof LocaleAdminLanguageAnalyticsRoute
  '/$locale/admin/migration-stats': typeof LocaleAdminMigrationStatsRoute
  '/$locale/admin/moderation': typeof LocaleAdminModerationRoute
  '/$locale/admin/rag-health': typeof LocaleAdminRagHealthRoute
  '/$locale/admin/users': typeof LocaleAdminUsersRoute
  '/$locale/admin/withdrawals': typeof LocaleAdminWithdrawalsRoute
  '/$locale/dashboard/ai-chat': typeof LocaleDashboardAiChatRoute
  '/$locale/dashboard/ai-features': typeof LocaleDashboardAiFeaturesRoute
  '/$locale/dashboard/ai-search': typeof LocaleDashboardAiSearchRoute
  '/$locale/dashboard/career-advisor': typeof LocaleDashboardCareerAdvisorRoute
  '/$locale/dashboard/cover-letter': typeof LocaleDashboardCoverLetterRoute
  '/$locale/dashboard/credits': typeof LocaleDashboardCreditsRoute
  '/$locale/dashboard/growth': typeof LocaleDashboardGrowthRoute
  '/$locale/dashboard/job-preferences': typeof LocaleDashboardJobPreferencesRoute
  '/$locale/dashboard/mock-interview': typeof LocaleDashboardMockInterviewRoute
  '/$locale/dashboard/overview': typeof LocaleDashboardOverviewRoute
  '/$locale/dashboard/profile': typeof LocaleDashboardProfileRoute
  '/$locale/dashboard/referral': typeof LocaleDashboardReferralRoute
  '/$locale/dashboard/reports': typeof LocaleDashboardReportsRoute
  '/$locale/dashboard/resume-analysis': typeof LocaleDashboardResumeAnalysisRoute
  '/$locale/dashboard/salary-insights': typeof LocaleDashboardSalaryInsightsRoute
  '/$locale/dashboard/salary-negotiation': typeof LocaleDashboardSalaryNegotiationRoute
  '/$locale/dashboard/settings': typeof LocaleDashboardSettingsRoute
  '/$locale/dashboard/subscription': typeof LocaleDashboardSubscriptionRoute
  '/$locale/dashboard/usage': typeof LocaleDashboardUsageRoute
  '/$locale/employer/$companyId': typeof LocaleEmployerCompanyIdRouteWithChildren
  '/$locale/jobs/$jobId': typeof LocaleJobsJobIdRoute
  '/$locale/oauth/callback': typeof LocaleOauthCallbackRoute
  '/$locale/settings/alerts': typeof LocaleSettingsAlertsRouteWithChildren
  '/$locale/settings/resume': typeof LocaleSettingsResumeRoute
  '/$locale/employer/create': typeof LocaleEmployerCreateLazyRoute
  '/$locale/dashboard/': typeof LocaleDashboardIndexRoute
  '/$locale/employer/': typeof LocaleEmployerIndexRoute
  '/$locale/admin/blog/queue': typeof LocaleAdminBlogQueueRoute
  '/$locale/employer/$companyId/applications': typeof LocaleEmployerCompanyIdApplicationsRoute
  '/$locale/employer/$companyId/billing': typeof LocaleEmployerCompanyIdBillingRoute
  '/$locale/employer/$companyId/jobs': typeof LocaleEmployerCompanyIdJobsRouteWithChildren
  '/$locale/employer/$companyId/settings': typeof LocaleEmployerCompanyIdSettingsRoute
  '/$locale/settings/alerts/new': typeof LocaleSettingsAlertsNewRoute
  '/$locale/employer/$companyId/': typeof LocaleEmployerCompanyIdIndexLazyRoute
  '/$locale/employer/$companyId/jobs/$jobId': typeof LocaleEmployerCompanyIdJobsJobIdRoute
  '/$locale/employer/$companyId/jobs/new': typeof LocaleEmployerCompanyIdJobsNewRoute
  '/$locale/employer/$companyId/jobs/': typeof LocaleEmployerCompanyIdJobsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/$locale'
    | '/$locale/2fa-challenge'
    | '/$locale/accessibility-statement'
    | '/$locale/admin'
    | '/$locale/browse'
    | '/$locale/contact'
    | '/$locale/cookie-policy'
    | '/$locale/cover-letter-generator'
    | '/$locale/dashboard'
    | '/$locale/email-preferences'
    | '/$locale/employer'
    | '/$locale/health'
    | '/$locale/job-tracker'
    | '/$locale/jobs'
    | '/$locale/legal-notice'
    | '/$locale/onboarding'
    | '/$locale/pricing'
    | '/$locale/privacy-policy'
    | '/$locale/refund-policy'
    | '/$locale/resume-generator'
    | '/$locale/sign-in'
    | '/$locale/sign-up'
    | '/$locale/terms-of-service'
    | '/$locale/verify-email'
    | '/$locale/welcome'
    | '/$locale/withdrawal-rights'
    | '/auth/login'
    | '/auth/register'
    | '/$locale/'
    | '/$locale/admin/ai-metrics'
    | '/$locale/admin/analytics'
    | '/$locale/admin/billing'
    | '/$locale/admin/docs-search'
    | '/$locale/admin/feature-flags'
    | '/$locale/admin/ingestion-health'
    | '/$locale/admin/language-analytics'
    | '/$locale/admin/migration-stats'
    | '/$locale/admin/moderation'
    | '/$locale/admin/rag-health'
    | '/$locale/admin/users'
    | '/$locale/admin/withdrawals'
    | '/$locale/dashboard/ai-chat'
    | '/$locale/dashboard/ai-features'
    | '/$locale/dashboard/ai-search'
    | '/$locale/dashboard/career-advisor'
    | '/$locale/dashboard/cover-letter'
    | '/$locale/dashboard/credits'
    | '/$locale/dashboard/growth'
    | '/$locale/dashboard/job-preferences'
    | '/$locale/dashboard/mock-interview'
    | '/$locale/dashboard/overview'
    | '/$locale/dashboard/profile'
    | '/$locale/dashboard/referral'
    | '/$locale/dashboard/reports'
    | '/$locale/dashboard/resume-analysis'
    | '/$locale/dashboard/salary-insights'
    | '/$locale/dashboard/salary-negotiation'
    | '/$locale/dashboard/settings'
    | '/$locale/dashboard/subscription'
    | '/$locale/dashboard/usage'
    | '/$locale/employer/$companyId'
    | '/$locale/jobs/$jobId'
    | '/$locale/oauth/callback'
    | '/$locale/settings/alerts'
    | '/$locale/settings/resume'
    | '/$locale/employer/create'
    | '/$locale/dashboard/'
    | '/$locale/employer/'
    | '/$locale/admin/blog/queue'
    | '/$locale/employer/$companyId/applications'
    | '/$locale/employer/$companyId/billing'
    | '/$locale/employer/$companyId/jobs'
    | '/$locale/employer/$companyId/settings'
    | '/$locale/settings/alerts/new'
    | '/$locale/employer/$companyId/'
    | '/$locale/employer/$companyId/jobs/$jobId'
    | '/$locale/employer/$companyId/jobs/new'
    | '/$locale/employer/$companyId/jobs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/$locale/2fa-challenge'
    | '/$locale/accessibility-statement'
    | '/$locale/admin'
    | '/$locale/browse'
    | '/$locale/contact'
    | '/$locale/cookie-policy'
    | '/$locale/cover-letter-generator'
    | '/$locale/email-preferences'
    | '/$locale/health'
    | '/$locale/job-tracker'
    | '/$locale/jobs'
    | '/$locale/legal-notice'
    | '/$locale/onboarding'
    | '/$locale/pricing'
    | '/$locale/privacy-policy'
    | '/$locale/refund-policy'
    | '/$locale/resume-generator'
    | '/$locale/sign-in'
    | '/$locale/sign-up'
    | '/$locale/terms-of-service'
    | '/$locale/verify-email'
    | '/$locale/welcome'
    | '/$locale/withdrawal-rights'
    | '/auth/login'
    | '/auth/register'
    | '/$locale'
    | '/$locale/admin/ai-metrics'
    | '/$locale/admin/analytics'
    | '/$locale/admin/billing'
    | '/$locale/admin/docs-search'
    | '/$locale/admin/feature-flags'
    | '/$locale/admin/ingestion-health'
    | '/$locale/admin/language-analytics'
    | '/$locale/admin/migration-stats'
    | '/$locale/admin/moderation'
    | '/$locale/admin/rag-health'
    | '/$locale/admin/users'
    | '/$locale/admin/withdrawals'
    | '/$locale/dashboard/ai-chat'
    | '/$locale/dashboard/ai-features'
    | '/$locale/dashboard/ai-search'
    | '/$locale/dashboard/career-advisor'
    | '/$locale/dashboard/cover-letter'
    | '/$locale/dashboard/credits'
    | '/$locale/dashboard/growth'
    | '/$locale/dashboard/job-preferences'
    | '/$locale/dashboard/mock-interview'
    | '/$locale/dashboard/overview'
    | '/$locale/dashboard/profile'
    | '/$locale/dashboard/referral'
    | '/$locale/dashboard/reports'
    | '/$locale/dashboard/resume-analysis'
    | '/$locale/dashboard/salary-insights'
    | '/$locale/dashboard/salary-negotiation'
    | '/$locale/dashboard/settings'
    | '/$locale/dashboard/subscription'
    | '/$locale/dashboard/usage'
    | '/$locale/jobs/$jobId'
    | '/$locale/oauth/callback'
    | '/$locale/settings/alerts'
    | '/$locale/settings/resume'
    | '/$locale/employer/create'
    | '/$locale/dashboard'
    | '/$locale/employer'
    | '/$locale/admin/blog/queue'
    | '/$locale/employer/$companyId/applications'
    | '/$locale/employer/$companyId/billing'
    | '/$locale/employer/$companyId/settings'
    | '/$locale/settings/alerts/new'
    | '/$locale/employer/$companyId'
    | '/$locale/employer/$companyId/jobs/$jobId'
    | '/$locale/employer/$companyId/jobs/new'
    | '/$locale/employer/$companyId/jobs'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/$locale'
    | '/$locale/2fa-challenge'
    | '/$locale/accessibility-statement'
    | '/$locale/admin'
    | '/$locale/browse'
    | '/$locale/contact'
    | '/$locale/cookie-policy'
    | '/$locale/cover-letter-generator'
    | '/$locale/dashboard'
    | '/$locale/email-preferences'
    | '/$locale/employer'
    | '/$locale/health'
    | '/$locale/job-tracker'
    | '/$locale/jobs'
    | '/$locale/legal-notice'
    | '/$locale/onboarding'
    | '/$locale/pricing'
    | '/$locale/privacy-policy'
    | '/$locale/refund-policy'
    | '/$locale/resume-generator'
    | '/$locale/sign-in'
    | '/$locale/sign-up'
    | '/$locale/terms-of-service'
    | '/$locale/verify-email'
    | '/$locale/welcome'
    | '/$locale/withdrawal-rights'
    | '/auth/login'
    | '/auth/register'
    | '/$locale/'
    | '/$locale/admin/ai-metrics'
    | '/$locale/admin/analytics'
    | '/$locale/admin/billing'
    | '/$locale/admin/docs-search'
    | '/$locale/admin/feature-flags'
    | '/$locale/admin/ingestion-health'
    | '/$locale/admin/language-analytics'
    | '/$locale/admin/migration-stats'
    | '/$locale/admin/moderation'
    | '/$locale/admin/rag-health'
    | '/$locale/admin/users'
    | '/$locale/admin/withdrawals'
    | '/$locale/dashboard/ai-chat'
    | '/$locale/dashboard/ai-features'
    | '/$locale/dashboard/ai-search'
    | '/$locale/dashboard/career-advisor'
    | '/$locale/dashboard/cover-letter'
    | '/$locale/dashboard/credits'
    | '/$locale/dashboard/growth'
    | '/$locale/dashboard/job-preferences'
    | '/$locale/dashboard/mock-interview'
    | '/$locale/dashboard/overview'
    | '/$locale/dashboard/profile'
    | '/$locale/dashboard/referral'
    | '/$locale/dashboard/reports'
    | '/$locale/dashboard/resume-analysis'
    | '/$locale/dashboard/salary-insights'
    | '/$locale/dashboard/salary-negotiation'
    | '/$locale/dashboard/settings'
    | '/$locale/dashboard/subscription'
    | '/$locale/dashboard/usage'
    | '/$locale/employer/$companyId'
    | '/$locale/jobs/$jobId'
    | '/$locale/oauth/callback'
    | '/$locale/settings/alerts'
    | '/$locale/settings/resume'
    | '/$locale/employer/create'
    | '/$locale/dashboard/'
    | '/$locale/employer/'
    | '/$locale/admin/blog/queue'
    | '/$locale/employer/$companyId/applications'
    | '/$locale/employer/$companyId/billing'
    | '/$locale/employer/$companyId/jobs'
    | '/$locale/employer/$companyId/settings'
    | '/$locale/settings/alerts/new'
    | '/$locale/employer/$companyId/'
    | '/$locale/employer/$companyId/jobs/$jobId'
    | '/$locale/employer/$companyId/jobs/new'
    | '/$locale/employer/$companyId/jobs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  LocaleRoute: typeof LocaleRouteWithChildren
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$locale': {
      id: '/$locale'
      path: '/$locale'
      fullPath: '/$locale'
      preLoaderRoute: typeof LocaleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale/': {
      id: '/$locale/'
      path: '/'
      fullPath: '/$locale/'
      preLoaderRoute: typeof LocaleIndexRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/auth/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale/withdrawal-rights': {
      id: '/$locale/withdrawal-rights'
      path: '/withdrawal-rights'
      fullPath: '/$locale/withdrawal-rights'
      preLoaderRoute: typeof LocaleWithdrawalRightsRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/welcome': {
      id: '/$locale/welcome'
      path: '/welcome'
      fullPath: '/$locale/welcome'
      preLoaderRoute: typeof LocaleWelcomeRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/verify-email': {
      id: '/$locale/verify-email'
      path: '/verify-email'
      fullPath: '/$locale/verify-email'
      preLoaderRoute: typeof LocaleVerifyEmailRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/terms-of-service': {
      id: '/$locale/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/$locale/terms-of-service'
      preLoaderRoute: typeof LocaleTermsOfServiceRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/sign-up': {
      id: '/$locale/sign-up'
      path: '/sign-up'
      fullPath: '/$locale/sign-up'
      preLoaderRoute: typeof LocaleSignUpRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/sign-in': {
      id: '/$locale/sign-in'
      path: '/sign-in'
      fullPath: '/$locale/sign-in'
      preLoaderRoute: typeof LocaleSignInRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/resume-generator': {
      id: '/$locale/resume-generator'
      path: '/resume-generator'
      fullPath: '/$locale/resume-generator'
      preLoaderRoute: typeof LocaleResumeGeneratorRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/refund-policy': {
      id: '/$locale/refund-policy'
      path: '/refund-policy'
      fullPath: '/$locale/refund-policy'
      preLoaderRoute: typeof LocaleRefundPolicyRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/privacy-policy': {
      id: '/$locale/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/$locale/privacy-policy'
      preLoaderRoute: typeof LocalePrivacyPolicyRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/pricing': {
      id: '/$locale/pricing'
      path: '/pricing'
      fullPath: '/$locale/pricing'
      preLoaderRoute: typeof LocalePricingRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/onboarding': {
      id: '/$locale/onboarding'
      path: '/onboarding'
      fullPath: '/$locale/onboarding'
      preLoaderRoute: typeof LocaleOnboardingRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/legal-notice': {
      id: '/$locale/legal-notice'
      path: '/legal-notice'
      fullPath: '/$locale/legal-notice'
      preLoaderRoute: typeof LocaleLegalNoticeRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/jobs': {
      id: '/$locale/jobs'
      path: '/jobs'
      fullPath: '/$locale/jobs'
      preLoaderRoute: typeof LocaleJobsRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/job-tracker': {
      id: '/$locale/job-tracker'
      path: '/job-tracker'
      fullPath: '/$locale/job-tracker'
      preLoaderRoute: typeof LocaleJobTrackerRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/health': {
      id: '/$locale/health'
      path: '/health'
      fullPath: '/$locale/health'
      preLoaderRoute: typeof LocaleHealthRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/employer': {
      id: '/$locale/employer'
      path: '/employer'
      fullPath: '/$locale/employer'
      preLoaderRoute: typeof LocaleEmployerRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/email-preferences': {
      id: '/$locale/email-preferences'
      path: '/email-preferences'
      fullPath: '/$locale/email-preferences'
      preLoaderRoute: typeof LocaleEmailPreferencesRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/dashboard': {
      id: '/$locale/dashboard'
      path: '/dashboard'
      fullPath: '/$locale/dashboard'
      preLoaderRoute: typeof LocaleDashboardRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/cover-letter-generator': {
      id: '/$locale/cover-letter-generator'
      path: '/cover-letter-generator'
      fullPath: '/$locale/cover-letter-generator'
      preLoaderRoute: typeof LocaleCoverLetterGeneratorRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/cookie-policy': {
      id: '/$locale/cookie-policy'
      path: '/cookie-policy'
      fullPath: '/$locale/cookie-policy'
      preLoaderRoute: typeof LocaleCookiePolicyRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/contact': {
      id: '/$locale/contact'
      path: '/contact'
      fullPath: '/$locale/contact'
      preLoaderRoute: typeof LocaleContactRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/browse': {
      id: '/$locale/browse'
      path: '/browse'
      fullPath: '/$locale/browse'
      preLoaderRoute: typeof LocaleBrowseRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/admin': {
      id: '/$locale/admin'
      path: '/admin'
      fullPath: '/$locale/admin'
      preLoaderRoute: typeof LocaleAdminRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/accessibility-statement': {
      id: '/$locale/accessibility-statement'
      path: '/accessibility-statement'
      fullPath: '/$locale/accessibility-statement'
      preLoaderRoute: typeof LocaleAccessibilityStatementRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/2fa-challenge': {
      id: '/$locale/2fa-challenge'
      path: '/2fa-challenge'
      fullPath: '/$locale/2fa-challenge'
      preLoaderRoute: typeof Locale2faChallengeRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/employer/': {
      id: '/$locale/employer/'
      path: '/'
      fullPath: '/$locale/employer/'
      preLoaderRoute: typeof LocaleEmployerIndexRouteImport
      parentRoute: typeof LocaleEmployerRoute
    }
    '/$locale/dashboard/': {
      id: '/$locale/dashboard/'
      path: '/'
      fullPath: '/$locale/dashboard/'
      preLoaderRoute: typeof LocaleDashboardIndexRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/employer/create': {
      id: '/$locale/employer/create'
      path: '/create'
      fullPath: '/$locale/employer/create'
      preLoaderRoute: typeof LocaleEmployerCreateLazyRouteImport
      parentRoute: typeof LocaleEmployerRoute
    }
    '/$locale/settings/resume': {
      id: '/$locale/settings/resume'
      path: '/settings/resume'
      fullPath: '/$locale/settings/resume'
      preLoaderRoute: typeof LocaleSettingsResumeRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/settings/alerts': {
      id: '/$locale/settings/alerts'
      path: '/settings/alerts'
      fullPath: '/$locale/settings/alerts'
      preLoaderRoute: typeof LocaleSettingsAlertsRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/oauth/callback': {
      id: '/$locale/oauth/callback'
      path: '/oauth/callback'
      fullPath: '/$locale/oauth/callback'
      preLoaderRoute: typeof LocaleOauthCallbackRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/jobs/$jobId': {
      id: '/$locale/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/$locale/jobs/$jobId'
      preLoaderRoute: typeof LocaleJobsJobIdRouteImport
      parentRoute: typeof LocaleJobsRoute
    }
    '/$locale/employer/$companyId': {
      id: '/$locale/employer/$companyId'
      path: '/$companyId'
      fullPath: '/$locale/employer/$companyId'
      preLoaderRoute: typeof LocaleEmployerCompanyIdRouteImport
      parentRoute: typeof LocaleEmployerRoute
    }
    '/$locale/dashboard/usage': {
      id: '/$locale/dashboard/usage'
      path: '/usage'
      fullPath: '/$locale/dashboard/usage'
      preLoaderRoute: typeof LocaleDashboardUsageRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/subscription': {
      id: '/$locale/dashboard/subscription'
      path: '/subscription'
      fullPath: '/$locale/dashboard/subscription'
      preLoaderRoute: typeof LocaleDashboardSubscriptionRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/settings': {
      id: '/$locale/dashboard/settings'
      path: '/settings'
      fullPath: '/$locale/dashboard/settings'
      preLoaderRoute: typeof LocaleDashboardSettingsRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/salary-negotiation': {
      id: '/$locale/dashboard/salary-negotiation'
      path: '/salary-negotiation'
      fullPath: '/$locale/dashboard/salary-negotiation'
      preLoaderRoute: typeof LocaleDashboardSalaryNegotiationRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/salary-insights': {
      id: '/$locale/dashboard/salary-insights'
      path: '/salary-insights'
      fullPath: '/$locale/dashboard/salary-insights'
      preLoaderRoute: typeof LocaleDashboardSalaryInsightsRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/resume-analysis': {
      id: '/$locale/dashboard/resume-analysis'
      path: '/resume-analysis'
      fullPath: '/$locale/dashboard/resume-analysis'
      preLoaderRoute: typeof LocaleDashboardResumeAnalysisRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/reports': {
      id: '/$locale/dashboard/reports'
      path: '/reports'
      fullPath: '/$locale/dashboard/reports'
      preLoaderRoute: typeof LocaleDashboardReportsRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/referral': {
      id: '/$locale/dashboard/referral'
      path: '/referral'
      fullPath: '/$locale/dashboard/referral'
      preLoaderRoute: typeof LocaleDashboardReferralRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/profile': {
      id: '/$locale/dashboard/profile'
      path: '/profile'
      fullPath: '/$locale/dashboard/profile'
      preLoaderRoute: typeof LocaleDashboardProfileRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/overview': {
      id: '/$locale/dashboard/overview'
      path: '/overview'
      fullPath: '/$locale/dashboard/overview'
      preLoaderRoute: typeof LocaleDashboardOverviewRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/mock-interview': {
      id: '/$locale/dashboard/mock-interview'
      path: '/mock-interview'
      fullPath: '/$locale/dashboard/mock-interview'
      preLoaderRoute: typeof LocaleDashboardMockInterviewRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/job-preferences': {
      id: '/$locale/dashboard/job-preferences'
      path: '/job-preferences'
      fullPath: '/$locale/dashboard/job-preferences'
      preLoaderRoute: typeof LocaleDashboardJobPreferencesRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/growth': {
      id: '/$locale/dashboard/growth'
      path: '/growth'
      fullPath: '/$locale/dashboard/growth'
      preLoaderRoute: typeof LocaleDashboardGrowthRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/credits': {
      id: '/$locale/dashboard/credits'
      path: '/credits'
      fullPath: '/$locale/dashboard/credits'
      preLoaderRoute: typeof LocaleDashboardCreditsRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/cover-letter': {
      id: '/$locale/dashboard/cover-letter'
      path: '/cover-letter'
      fullPath: '/$locale/dashboard/cover-letter'
      preLoaderRoute: typeof LocaleDashboardCoverLetterRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/career-advisor': {
      id: '/$locale/dashboard/career-advisor'
      path: '/career-advisor'
      fullPath: '/$locale/dashboard/career-advisor'
      preLoaderRoute: typeof LocaleDashboardCareerAdvisorRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/ai-search': {
      id: '/$locale/dashboard/ai-search'
      path: '/ai-search'
      fullPath: '/$locale/dashboard/ai-search'
      preLoaderRoute: typeof LocaleDashboardAiSearchRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/ai-features': {
      id: '/$locale/dashboard/ai-features'
      path: '/ai-features'
      fullPath: '/$locale/dashboard/ai-features'
      preLoaderRoute: typeof LocaleDashboardAiFeaturesRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/dashboard/ai-chat': {
      id: '/$locale/dashboard/ai-chat'
      path: '/ai-chat'
      fullPath: '/$locale/dashboard/ai-chat'
      preLoaderRoute: typeof LocaleDashboardAiChatRouteImport
      parentRoute: typeof LocaleDashboardRoute
    }
    '/$locale/admin/withdrawals': {
      id: '/$locale/admin/withdrawals'
      path: '/withdrawals'
      fullPath: '/$locale/admin/withdrawals'
      preLoaderRoute: typeof LocaleAdminWithdrawalsRouteImport
      parentRoute: typeof LocaleAdminRoute
    }
    '/$locale/admin/users': {
      id: '/$locale/admin/users'
      path: '/users'
      fullPath: '/$locale/admin/users'
      preLoaderRoute: typeof LocaleAdminUsersRouteImport
      parentRoute: typeof LocaleAdminRoute
    }
    '/$locale/admin/rag-health': {
      id: '/$locale/admin/rag-health'
      path: '/rag-health'
      fullPath: '/$locale/admin/rag-health'
      preLoaderRoute: typeof LocaleAdminRagHealthRouteImport
      parentRoute: typeof LocaleAdminRoute
    }
    '/$locale/admin/moderation': {
      id: '/$locale/admin/moderation'
      path: '/moderation'
      fullPath: '/$locale/admin/moderation'
      preLoaderRoute: typeof LocaleAdminModerationRouteImport
      parentRoute: typeof LocaleAdminRoute
    }
    '/$locale/admin/migration-stats': {
      id: '/$locale/admin/migration-stats'
      path: '/migration-stats'
      fullPath: '/$locale/admin/migration-stats'
      preLoaderRoute: typeof LocaleAdminMigrationStatsRouteImport
      parentRoute: typeof LocaleAdminRoute
    }
    '/$locale/admin/language-analytics': {
      id: '/$locale/admin/language-analytics'
      path: '/language-analytics'
      fullPath: '/$locale/admin/language-analytics'
      preLoaderRoute: typeof LocaleAdminLanguageAnalyticsRouteImport
      parentRoute: typeof LocaleAdminRoute
    }
    '/$locale/admin/ingestion-health': {
      id: '/$locale/admin/ingestion-health'
      path: '/ingestion-health'
      fullPath: '/$locale/admin/ingestion-health'
      preLoaderRoute: typeof LocaleAdminIngestionHealthRouteImport
      parentRoute: typeof LocaleAdminRoute
    }
    '/$locale/admin/feature-flags': {
      id: '/$locale/admin/feature-flags'
      path: '/feature-flags'
      fullPath: '/$locale/admin/feature-flags'
      preLoaderRoute: typeof LocaleAdminFeatureFlagsRouteImport
      parentRoute: typeof LocaleAdminRoute
    }
    '/$locale/admin/docs-search': {
      id: '/$locale/admin/docs-search'
      path: '/docs-search'
      fullPath: '/$locale/admin/docs-search'
      preLoaderRoute: typeof LocaleAdminDocsSearchRouteImport
      parentRoute: typeof LocaleAdminRoute
    }
    '/$locale/admin/billing': {
      id: '/$locale/admin/billing'
      path: '/billing'
      fullPath: '/$locale/admin/billing'
      preLoaderRoute: typeof LocaleAdminBillingRouteImport
      parentRoute: typeof LocaleAdminRoute
    }
    '/$locale/admin/analytics': {
      id: '/$locale/admin/analytics'
      path: '/analytics'
      fullPath: '/$locale/admin/analytics'
      preLoaderRoute: typeof LocaleAdminAnalyticsRouteImport
      parentRoute: typeof LocaleAdminRoute
    }
    '/$locale/admin/ai-metrics': {
      id: '/$locale/admin/ai-metrics'
      path: '/ai-metrics'
      fullPath: '/$locale/admin/ai-metrics'
      preLoaderRoute: typeof LocaleAdminAiMetricsRouteImport
      parentRoute: typeof LocaleAdminRoute
    }
    '/$locale/employer/$companyId/': {
      id: '/$locale/employer/$companyId/'
      path: '/'
      fullPath: '/$locale/employer/$companyId/'
      preLoaderRoute: typeof LocaleEmployerCompanyIdIndexLazyRouteImport
      parentRoute: typeof LocaleEmployerCompanyIdRoute
    }
    '/$locale/settings/alerts/new': {
      id: '/$locale/settings/alerts/new'
      path: '/new'
      fullPath: '/$locale/settings/alerts/new'
      preLoaderRoute: typeof LocaleSettingsAlertsNewRouteImport
      parentRoute: typeof LocaleSettingsAlertsRoute
    }
    '/$locale/employer/$companyId/settings': {
      id: '/$locale/employer/$companyId/settings'
      path: '/settings'
      fullPath: '/$locale/employer/$companyId/settings'
      preLoaderRoute: typeof LocaleEmployerCompanyIdSettingsRouteImport
      parentRoute: typeof LocaleEmployerCompanyIdRoute
    }
    '/$locale/employer/$companyId/jobs': {
      id: '/$locale/employer/$companyId/jobs'
      path: '/jobs'
      fullPath: '/$locale/employer/$companyId/jobs'
      preLoaderRoute: typeof LocaleEmployerCompanyIdJobsRouteImport
      parentRoute: typeof LocaleEmployerCompanyIdRoute
    }
    '/$locale/employer/$companyId/billing': {
      id: '/$locale/employer/$companyId/billing'
      path: '/billing'
      fullPath: '/$locale/employer/$companyId/billing'
      preLoaderRoute: typeof LocaleEmployerCompanyIdBillingRouteImport
      parentRoute: typeof LocaleEmployerCompanyIdRoute
    }
    '/$locale/employer/$companyId/applications': {
      id: '/$locale/employer/$companyId/applications'
      path: '/applications'
      fullPath: '/$locale/employer/$companyId/applications'
      preLoaderRoute: typeof LocaleEmployerCompanyIdApplicationsRouteImport
      parentRoute: typeof LocaleEmployerCompanyIdRoute
    }
    '/$locale/admin/blog/queue': {
      id: '/$locale/admin/blog/queue'
      path: '/blog/queue'
      fullPath: '/$locale/admin/blog/queue'
      preLoaderRoute: typeof LocaleAdminBlogQueueRouteImport
      parentRoute: typeof LocaleAdminRoute
    }
    '/$locale/employer/$companyId/jobs/': {
      id: '/$locale/employer/$companyId/jobs/'
      path: '/'
      fullPath: '/$locale/employer/$companyId/jobs/'
      preLoaderRoute: typeof LocaleEmployerCompanyIdJobsIndexRouteImport
      parentRoute: typeof LocaleEmployerCompanyIdJobsRoute
    }
    '/$locale/employer/$companyId/jobs/new': {
      id: '/$locale/employer/$companyId/jobs/new'
      path: '/new'
      fullPath: '/$locale/employer/$companyId/jobs/new'
      preLoaderRoute: typeof LocaleEmployerCompanyIdJobsNewRouteImport
      parentRoute: typeof LocaleEmployerCompanyIdJobsRoute
    }
    '/$locale/employer/$companyId/jobs/$jobId': {
      id: '/$locale/employer/$companyId/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/$locale/employer/$companyId/jobs/$jobId'
      preLoaderRoute: typeof LocaleEmployerCompanyIdJobsJobIdRouteImport
      parentRoute: typeof LocaleEmployerCompanyIdJobsRoute
    }
  }
}

interface LocaleAdminRouteChildren {
  LocaleAdminAiMetricsRoute: typeof LocaleAdminAiMetricsRoute
  LocaleAdminAnalyticsRoute: typeof LocaleAdminAnalyticsRoute
  LocaleAdminBillingRoute: typeof LocaleAdminBillingRoute
  LocaleAdminDocsSearchRoute: typeof LocaleAdminDocsSearchRoute
  LocaleAdminFeatureFlagsRoute: typeof LocaleAdminFeatureFlagsRoute
  LocaleAdminIngestionHealthRoute: typeof LocaleAdminIngestionHealthRoute
  LocaleAdminLanguageAnalyticsRoute: typeof LocaleAdminLanguageAnalyticsRoute
  LocaleAdminMigrationStatsRoute: typeof LocaleAdminMigrationStatsRoute
  LocaleAdminModerationRoute: typeof LocaleAdminModerationRoute
  LocaleAdminRagHealthRoute: typeof LocaleAdminRagHealthRoute
  LocaleAdminUsersRoute: typeof LocaleAdminUsersRoute
  LocaleAdminWithdrawalsRoute: typeof LocaleAdminWithdrawalsRoute
  LocaleAdminBlogQueueRoute: typeof LocaleAdminBlogQueueRoute
}

const LocaleAdminRouteChildren: LocaleAdminRouteChildren = {
  LocaleAdminAiMetricsRoute: LocaleAdminAiMetricsRoute,
  LocaleAdminAnalyticsRoute: LocaleAdminAnalyticsRoute,
  LocaleAdminBillingRoute: LocaleAdminBillingRoute,
  LocaleAdminDocsSearchRoute: LocaleAdminDocsSearchRoute,
  LocaleAdminFeatureFlagsRoute: LocaleAdminFeatureFlagsRoute,
  LocaleAdminIngestionHealthRoute: LocaleAdminIngestionHealthRoute,
  LocaleAdminLanguageAnalyticsRoute: LocaleAdminLanguageAnalyticsRoute,
  LocaleAdminMigrationStatsRoute: LocaleAdminMigrationStatsRoute,
  LocaleAdminModerationRoute: LocaleAdminModerationRoute,
  LocaleAdminRagHealthRoute: LocaleAdminRagHealthRoute,
  LocaleAdminUsersRoute: LocaleAdminUsersRoute,
  LocaleAdminWithdrawalsRoute: LocaleAdminWithdrawalsRoute,
  LocaleAdminBlogQueueRoute: LocaleAdminBlogQueueRoute,
}

const LocaleAdminRouteWithChildren = LocaleAdminRoute._addFileChildren(
  LocaleAdminRouteChildren,
)

interface LocaleDashboardRouteChildren {
  LocaleDashboardAiChatRoute: typeof LocaleDashboardAiChatRoute
  LocaleDashboardAiFeaturesRoute: typeof LocaleDashboardAiFeaturesRoute
  LocaleDashboardAiSearchRoute: typeof LocaleDashboardAiSearchRoute
  LocaleDashboardCareerAdvisorRoute: typeof LocaleDashboardCareerAdvisorRoute
  LocaleDashboardCoverLetterRoute: typeof LocaleDashboardCoverLetterRoute
  LocaleDashboardCreditsRoute: typeof LocaleDashboardCreditsRoute
  LocaleDashboardGrowthRoute: typeof LocaleDashboardGrowthRoute
  LocaleDashboardJobPreferencesRoute: typeof LocaleDashboardJobPreferencesRoute
  LocaleDashboardMockInterviewRoute: typeof LocaleDashboardMockInterviewRoute
  LocaleDashboardOverviewRoute: typeof LocaleDashboardOverviewRoute
  LocaleDashboardProfileRoute: typeof LocaleDashboardProfileRoute
  LocaleDashboardReferralRoute: typeof LocaleDashboardReferralRoute
  LocaleDashboardReportsRoute: typeof LocaleDashboardReportsRoute
  LocaleDashboardResumeAnalysisRoute: typeof LocaleDashboardResumeAnalysisRoute
  LocaleDashboardSalaryInsightsRoute: typeof LocaleDashboardSalaryInsightsRoute
  LocaleDashboardSalaryNegotiationRoute: typeof LocaleDashboardSalaryNegotiationRoute
  LocaleDashboardSettingsRoute: typeof LocaleDashboardSettingsRoute
  LocaleDashboardSubscriptionRoute: typeof LocaleDashboardSubscriptionRoute
  LocaleDashboardUsageRoute: typeof LocaleDashboardUsageRoute
  LocaleDashboardIndexRoute: typeof LocaleDashboardIndexRoute
}

const LocaleDashboardRouteChildren: LocaleDashboardRouteChildren = {
  LocaleDashboardAiChatRoute: LocaleDashboardAiChatRoute,
  LocaleDashboardAiFeaturesRoute: LocaleDashboardAiFeaturesRoute,
  LocaleDashboardAiSearchRoute: LocaleDashboardAiSearchRoute,
  LocaleDashboardCareerAdvisorRoute: LocaleDashboardCareerAdvisorRoute,
  LocaleDashboardCoverLetterRoute: LocaleDashboardCoverLetterRoute,
  LocaleDashboardCreditsRoute: LocaleDashboardCreditsRoute,
  LocaleDashboardGrowthRoute: LocaleDashboardGrowthRoute,
  LocaleDashboardJobPreferencesRoute: LocaleDashboardJobPreferencesRoute,
  LocaleDashboardMockInterviewRoute: LocaleDashboardMockInterviewRoute,
  LocaleDashboardOverviewRoute: LocaleDashboardOverviewRoute,
  LocaleDashboardProfileRoute: LocaleDashboardProfileRoute,
  LocaleDashboardReferralRoute: LocaleDashboardReferralRoute,
  LocaleDashboardReportsRoute: LocaleDashboardReportsRoute,
  LocaleDashboardResumeAnalysisRoute: LocaleDashboardResumeAnalysisRoute,
  LocaleDashboardSalaryInsightsRoute: LocaleDashboardSalaryInsightsRoute,
  LocaleDashboardSalaryNegotiationRoute: LocaleDashboardSalaryNegotiationRoute,
  LocaleDashboardSettingsRoute: LocaleDashboardSettingsRoute,
  LocaleDashboardSubscriptionRoute: LocaleDashboardSubscriptionRoute,
  LocaleDashboardUsageRoute: LocaleDashboardUsageRoute,
  LocaleDashboardIndexRoute: LocaleDashboardIndexRoute,
}

const LocaleDashboardRouteWithChildren = LocaleDashboardRoute._addFileChildren(
  LocaleDashboardRouteChildren,
)

interface LocaleEmployerCompanyIdJobsRouteChildren {
  LocaleEmployerCompanyIdJobsJobIdRoute: typeof LocaleEmployerCompanyIdJobsJobIdRoute
  LocaleEmployerCompanyIdJobsNewRoute: typeof LocaleEmployerCompanyIdJobsNewRoute
  LocaleEmployerCompanyIdJobsIndexRoute: typeof LocaleEmployerCompanyIdJobsIndexRoute
}

const LocaleEmployerCompanyIdJobsRouteChildren: LocaleEmployerCompanyIdJobsRouteChildren =
  {
    LocaleEmployerCompanyIdJobsJobIdRoute:
      LocaleEmployerCompanyIdJobsJobIdRoute,
    LocaleEmployerCompanyIdJobsNewRoute: LocaleEmployerCompanyIdJobsNewRoute,
    LocaleEmployerCompanyIdJobsIndexRoute:
      LocaleEmployerCompanyIdJobsIndexRoute,
  }

const LocaleEmployerCompanyIdJobsRouteWithChildren =
  LocaleEmployerCompanyIdJobsRoute._addFileChildren(
    LocaleEmployerCompanyIdJobsRouteChildren,
  )

interface LocaleEmployerCompanyIdRouteChildren {
  LocaleEmployerCompanyIdApplicationsRoute: typeof LocaleEmployerCompanyIdApplicationsRoute
  LocaleEmployerCompanyIdBillingRoute: typeof LocaleEmployerCompanyIdBillingRoute
  LocaleEmployerCompanyIdJobsRoute: typeof LocaleEmployerCompanyIdJobsRouteWithChildren
  LocaleEmployerCompanyIdSettingsRoute: typeof LocaleEmployerCompanyIdSettingsRoute
  LocaleEmployerCompanyIdIndexLazyRoute: typeof LocaleEmployerCompanyIdIndexLazyRoute
}

const LocaleEmployerCompanyIdRouteChildren: LocaleEmployerCompanyIdRouteChildren =
  {
    LocaleEmployerCompanyIdApplicationsRoute:
      LocaleEmployerCompanyIdApplicationsRoute,
    LocaleEmployerCompanyIdBillingRoute: LocaleEmployerCompanyIdBillingRoute,
    LocaleEmployerCompanyIdJobsRoute:
      LocaleEmployerCompanyIdJobsRouteWithChildren,
    LocaleEmployerCompanyIdSettingsRoute: LocaleEmployerCompanyIdSettingsRoute,
    LocaleEmployerCompanyIdIndexLazyRoute:
      LocaleEmployerCompanyIdIndexLazyRoute,
  }

const LocaleEmployerCompanyIdRouteWithChildren =
  LocaleEmployerCompanyIdRoute._addFileChildren(
    LocaleEmployerCompanyIdRouteChildren,
  )

interface LocaleEmployerRouteChildren {
  LocaleEmployerCompanyIdRoute: typeof LocaleEmployerCompanyIdRouteWithChildren
  LocaleEmployerCreateLazyRoute: typeof LocaleEmployerCreateLazyRoute
  LocaleEmployerIndexRoute: typeof LocaleEmployerIndexRoute
}

const LocaleEmployerRouteChildren: LocaleEmployerRouteChildren = {
  LocaleEmployerCompanyIdRoute: LocaleEmployerCompanyIdRouteWithChildren,
  LocaleEmployerCreateLazyRoute: LocaleEmployerCreateLazyRoute,
  LocaleEmployerIndexRoute: LocaleEmployerIndexRoute,
}

const LocaleEmployerRouteWithChildren = LocaleEmployerRoute._addFileChildren(
  LocaleEmployerRouteChildren,
)

interface LocaleJobsRouteChildren {
  LocaleJobsJobIdRoute: typeof LocaleJobsJobIdRoute
}

const LocaleJobsRouteChildren: LocaleJobsRouteChildren = {
  LocaleJobsJobIdRoute: LocaleJobsJobIdRoute,
}

const LocaleJobsRouteWithChildren = LocaleJobsRoute._addFileChildren(
  LocaleJobsRouteChildren,
)

interface LocaleSettingsAlertsRouteChildren {
  LocaleSettingsAlertsNewRoute: typeof LocaleSettingsAlertsNewRoute
}

const LocaleSettingsAlertsRouteChildren: LocaleSettingsAlertsRouteChildren = {
  LocaleSettingsAlertsNewRoute: LocaleSettingsAlertsNewRoute,
}

const LocaleSettingsAlertsRouteWithChildren =
  LocaleSettingsAlertsRoute._addFileChildren(LocaleSettingsAlertsRouteChildren)

interface LocaleRouteChildren {
  Locale2faChallengeRoute: typeof Locale2faChallengeRoute
  LocaleAccessibilityStatementRoute: typeof LocaleAccessibilityStatementRoute
  LocaleAdminRoute: typeof LocaleAdminRouteWithChildren
  LocaleBrowseRoute: typeof LocaleBrowseRoute
  LocaleContactRoute: typeof LocaleContactRoute
  LocaleCookiePolicyRoute: typeof LocaleCookiePolicyRoute
  LocaleCoverLetterGeneratorRoute: typeof LocaleCoverLetterGeneratorRoute
  LocaleDashboardRoute: typeof LocaleDashboardRouteWithChildren
  LocaleEmailPreferencesRoute: typeof LocaleEmailPreferencesRoute
  LocaleEmployerRoute: typeof LocaleEmployerRouteWithChildren
  LocaleHealthRoute: typeof LocaleHealthRoute
  LocaleJobTrackerRoute: typeof LocaleJobTrackerRoute
  LocaleJobsRoute: typeof LocaleJobsRouteWithChildren
  LocaleLegalNoticeRoute: typeof LocaleLegalNoticeRoute
  LocaleOnboardingRoute: typeof LocaleOnboardingRoute
  LocalePricingRoute: typeof LocalePricingRoute
  LocalePrivacyPolicyRoute: typeof LocalePrivacyPolicyRoute
  LocaleRefundPolicyRoute: typeof LocaleRefundPolicyRoute
  LocaleResumeGeneratorRoute: typeof LocaleResumeGeneratorRoute
  LocaleSignInRoute: typeof LocaleSignInRoute
  LocaleSignUpRoute: typeof LocaleSignUpRoute
  LocaleTermsOfServiceRoute: typeof LocaleTermsOfServiceRoute
  LocaleVerifyEmailRoute: typeof LocaleVerifyEmailRoute
  LocaleWelcomeRoute: typeof LocaleWelcomeRoute
  LocaleWithdrawalRightsRoute: typeof LocaleWithdrawalRightsRoute
  LocaleIndexRoute: typeof LocaleIndexRoute
  LocaleOauthCallbackRoute: typeof LocaleOauthCallbackRoute
  LocaleSettingsAlertsRoute: typeof LocaleSettingsAlertsRouteWithChildren
  LocaleSettingsResumeRoute: typeof LocaleSettingsResumeRoute
}

const LocaleRouteChildren: LocaleRouteChildren = {
  Locale2faChallengeRoute: Locale2faChallengeRoute,
  LocaleAccessibilityStatementRoute: LocaleAccessibilityStatementRoute,
  LocaleAdminRoute: LocaleAdminRouteWithChildren,
  LocaleBrowseRoute: LocaleBrowseRoute,
  LocaleContactRoute: LocaleContactRoute,
  LocaleCookiePolicyRoute: LocaleCookiePolicyRoute,
  LocaleCoverLetterGeneratorRoute: LocaleCoverLetterGeneratorRoute,
  LocaleDashboardRoute: LocaleDashboardRouteWithChildren,
  LocaleEmailPreferencesRoute: LocaleEmailPreferencesRoute,
  LocaleEmployerRoute: LocaleEmployerRouteWithChildren,
  LocaleHealthRoute: LocaleHealthRoute,
  LocaleJobTrackerRoute: LocaleJobTrackerRoute,
  LocaleJobsRoute: LocaleJobsRouteWithChildren,
  LocaleLegalNoticeRoute: LocaleLegalNoticeRoute,
  LocaleOnboardingRoute: LocaleOnboardingRoute,
  LocalePricingRoute: LocalePricingRoute,
  LocalePrivacyPolicyRoute: LocalePrivacyPolicyRoute,
  LocaleRefundPolicyRoute: LocaleRefundPolicyRoute,
  LocaleResumeGeneratorRoute: LocaleResumeGeneratorRoute,
  LocaleSignInRoute: LocaleSignInRoute,
  LocaleSignUpRoute: LocaleSignUpRoute,
  LocaleTermsOfServiceRoute: LocaleTermsOfServiceRoute,
  LocaleVerifyEmailRoute: LocaleVerifyEmailRoute,
  LocaleWelcomeRoute: LocaleWelcomeRoute,
  LocaleWithdrawalRightsRoute: LocaleWithdrawalRightsRoute,
  LocaleIndexRoute: LocaleIndexRoute,
  LocaleOauthCallbackRoute: LocaleOauthCallbackRoute,
  LocaleSettingsAlertsRoute: LocaleSettingsAlertsRouteWithChildren,
  LocaleSettingsResumeRoute: LocaleSettingsResumeRoute,
}

const LocaleRouteWithChildren =
  LocaleRoute._addFileChildren(LocaleRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  LocaleRoute: LocaleRouteWithChildren,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
